import { Component } from '@angular/core';

@Component({
  selector: 'app-icd10-code-edit',
  imports: [],
  templateUrl: './icd10-code-edit.html',
  styleUrl: './icd10-code-edit.scss',
})
export class Icd10CodeEditComponent {}
